import { useNavigate } from 'react-router-dom';
import { ProjectType } from 'nekst-api';

export default function useSettingsNavigator() {
  const navigate = useNavigate();
  const getCustomRolesLink = () => '/settings/roles';

  const getProfileLink = () => '/settings/profile';

  const getUpdatePasswordPageLink = () => '/settings/password';

  const getBillingPageLink = () => '/settings/billing';

  const getProjectDetailsLink = (projectType: ProjectType) => `/settings/detailboxes/${projectType.toLowerCase()}`;

  const openUpdateProfilePage = () => navigate(getProfileLink());

  const openUpdatePasswordPage = () => navigate(getUpdatePasswordPageLink());

  const openBillingPage = () => navigate(getBillingPageLink());

  const openCustomRolesList = () => navigate(getCustomRolesLink());

  const isBillingPage = () => window.location.pathname.startsWith(getBillingPageLink());

  const openProjectDetailsFieldPage = (projectType: ProjectType) => navigate(
    getProjectDetailsLink(projectType),
  );

  const getClientPortalSettingsLink = () => '/settings/clientportal';

  const openClientPortalSettingsPage = () => navigate(getClientPortalSettingsLink());

  const getServiceProvidersLink = () => '/settings/serviceproviders';

  const openServiceProvidersPage = () => navigate(getServiceProvidersLink());

  const getImpersonateUserLink = () => '/admin/users';

  const getAiTrainerLink = () => '/admin/aitrainer';

  const openImpersonateUserLinkPage = () => navigate(getImpersonateUserLink());

  const getDocumentLabelsLink = () => '/settings/documentlabels';

  const openDocumentLabelsPage = () => navigate(getDocumentLabelsLink());

  const getDocumentsTemplatesLink = () => '/settings/documentstemplates';

  const openDocumentsTemplatesPage = () => navigate(getDocumentsTemplatesLink());


  const getDefaultPortalConfigurationLink = (projectType: ProjectType) => `/settings/clientportal/${projectType.toLowerCase()}/default`;

  return {
    getProfileLink,
    getUpdatePasswordPageLink,
    getCustomRolesLink,
    getBillingPageLink,
    getProjectDetailsLink,
    openUpdateProfilePage,
    openUpdatePasswordPage,
    openBillingPage,
    openCustomRolesList,
    openProjectDetailsFieldPage,
    isBillingPage,
    getClientPortalSettingsLink,
    openClientPortalSettingsPage,
    getServiceProvidersLink,
    openServiceProvidersPage,
    getImpersonateUserLink,
    getAiTrainerLink,
    openImpersonateUserLinkPage,
    getDocumentLabelsLink,
    openDocumentLabelsPage,
    getDocumentsTemplatesLink,
    openDocumentsTemplatesPage,
    getDefaultPortalConfigurationLink,
  };
}
